import React from 'react';
import { Dialog } from 'components/common';
import { Typography } from '@material-ui/core';

interface Props {
  open: boolean;
  onClose: () => void;
}

const PaymentMethodsErrorDialog = ({ open, onClose }: Props) => {
  return (
    <Dialog
      open={open}
      onCancel={onClose}
      cancelSize={12}
      cancelText="Close"
      title="Payment Methods Unavailable">
      <Typography>
        Payment options are temporarily disabled for your account. Please contact support for
        assistance.
      </Typography>
    </Dialog>
  );
};

export default PaymentMethodsErrorDialog;
